import axios from 'axios';
import { domain } from './domain';


export const createUser = (token, data) => {
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        data,
    };
    return axios(`${domain}/paneluser/createuser`, requestOptions)
        .then((response) => {
            if (response.data.code) {
                return response;
            }
            throw new Error('Bağlantı hatası!');
        })
        .catch((error) => {
            return error;
        });
};

export const updateUser = (token, data) => {
    const requestOptions = {
        method: 'PUT',
        headers: {
            'Content-type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        data,
    };
    return axios(`${domain}/paneluser`, requestOptions)
        .then((response) => {
            if (response.data.code) {
                return response;
            }
            throw new Error('Bağlantı hatası!');
        })
        .catch((error) => {
            return error;
        });
};

export const resetPassword = (token, data) => {
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        data,
    };
    return axios(`${domain}/paneluser/reset`, requestOptions)
        .then((response) => {
            if (response.data.code) {
                return response;
            }
            throw new Error('Bağlantı hatası!');
        })
        .catch((error) => {
            return error;
        });
};

export const getUserDataById = (token, data) => {
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        data,
    };
    return axios(`${domain}/paneluser/getuserdatabyid`, requestOptions)
        .then((response) => {
            if (response.data.code) {
                return response;
            }
            throw new Error('Bağlantı hatası!');
        })
        .catch((error) => {
            return error;
        });
};

export const updatePassword = (token, data) => {
    const requestOptions = {
        method: 'PUT',
        headers: {
            'Content-type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        data,
    };
    return axios(`${domain}/paneluser/password`, requestOptions)
        .then((response) => {
            if (response.data.code) {
                return response;
            }
            throw new Error('Bağlantı hatası!');
        })
        .catch((error) => {
            return error;
        });
};

export const checkEmail = (data) => {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-type': 'application/json' },
        data,
    };
    return axios(`${domain}/paneluser/email`, requestOptions)
        .then((response) => {
            if (response.data.code) {
                return response;
            }
            throw new Error('Bağlantı hatası!');
        })
        .catch((error) => {
            return error;
        });
};

export const auth = (data) => {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-type': 'application/json' },
        data
    };
    return axios(`${domain}/paneluser`, requestOptions)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error;
        });
};

export const tokenAuth = (token) => {
    const requestOptions = {
        method: 'GET',
        headers: {
            'Content-type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
    };
    return axios(`${domain}/paneluser`, requestOptions)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error;
        });
};

export const getCompanyUsers = (token, data) => {
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        data,
    };
    return axios(`${domain}/paneluser/getcompany`, requestOptions)
        .then((response) => {
            if (response.data.code) {
                return response;
            }
            throw new Error('Bağlantı hatası!');
        })
        .catch((error) => {
            return error;
        });
};

export const updateAvatar = (token, data) => {
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-type': 'multipart/form-data',
            'Authorization': `Bearer ${token}`
        },
        data,
    };
    return axios(`${domain}/paneluser/avatar`, requestOptions)
        .then((response) => {
            if (response.data.code) {
                return response;
            }
            throw new Error('Bağlantı hatası!');
        })
        .catch((error) => {
            return error;
        });
};

export const checkUser = (token, data) => {
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        data,
    };
    return axios(`${domain}/user/checkuser`, requestOptions)
        .then((response) => {
            if (response.data.code) {
                return response;
            }
            throw new Error('Bağlantı hatası!');
        })
        .catch((error) => {
            return error;
        });
};

export const assignCardPanelUser = (token, data) => {
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        data,
    };
    return axios(`${domain}/paneluser/assigncard`, requestOptions)
        .then((response) => {
            if (response.data.code) {
                return response;
            }
            throw new Error('Bağlantı hatası!');
        })
        .catch((error) => {
            return error;
        });
};